import classNames from "classnames";
import { PureComponent } from "react";

interface IconToggleProps {
  active: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  iconDisabled?: boolean;
  activeIconClass: string[];
  inActiveIconClass: string[];
  baseClassName?: string[];
  onToggle: (active: boolean) => void;
}

export default class IconToggle extends PureComponent<IconToggleProps> {
  public render() {
    const baseClasses = classNames(... this.props.baseClassName, { disabled: this.props.disabled ? true : false });
    const iconClasses = this.props.active ? classNames(...this.props.activeIconClass) : classNames(...this.props.inActiveIconClass);

    if (this.props.iconDisabled === true) {
      return (
        <label className={baseClasses}>{this.props.children}</label>
      );
    } else {
      return (
        <label className={baseClasses} onClick={this.props.disabled ? null : this.handleClick}><i className={iconClasses} />{this.props.children}</label>
      );
    }
  }

  private handleClick = () => {
    this.props.onToggle(!this.props.active);
  }
}
